import NoLoginPage from 'components/layout/newOnboarding/NoLogInPage';
import styled       from '@emotion/styled';
import { useAtom }  from "jotai";
import Checkbox from './Checkbox';
import Balloon  from 'components/ui/Balloon';
import { useNavigate } from 'react-router-dom';
import { Button, ContextContainer,RadioButton}       from "components/ui";
import { checkedBoxesAtom, SelectedRadiobuttonAtom } from "components/pages/Onboarding/onboardingAtom";
import ReactGA from "react-ga4";
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'js-cookie';


const Elem:React.FC<any> = () => {
  const [ selectedOption, setSelectedOption ] = useAtom(SelectedRadiobuttonAtom);
  const [ checkboxes, setCheckboxes ] = useAtom(checkedBoxesAtom);
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const navigator = useNavigate();

  //전체 체크박스를 클릭하는 함수
  const handleAllCheckboxChange = (e:any) => {
    const { checked } = e.target;
    setCheckboxes({
      termsCondition : checked,
      personalInformation : checked,
      marketingConstent : checked
    });
  };

  // 개별 체크박스를 클릭하는 함수
  const handleCheckboxChange = (event:any) => {
    const { name, checked } = event.target;
    setCheckboxes(prevCheckboxes => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleOptionChange = (e:any) => {
    setSelectedOption(e.target.value);
  }

  interface Ga4Param{
    category:string;
    action : string;
    label: string;
    companyId:number
  }

  let ga4Params:Ga4Param;
  const handleCardRegistration = (e:any) => {
    if (checkboxes.termsCondition && checkboxes.personalInformation) {
      const fbc = Cookies.get('_fbc') || "";

      ReactPixel.fbq('track', 'InitiateCheckout', {
        content_name: 'Free Trial Photos',
        content_category: 'Free Trial',
        value: 10000,
        currency: 'KRW',
        gender: "female",
        country: "KR",
        content_type: 'product',
        fbc,
      })

      if (selectedOption === 'option1') {
        navigator("/registration/kakao")
        ga4Params = {
          "category": "Button",
          "action" : "Click",
          "label" : "3/3 complete: register payment-kakao",
          "companyId" : 2
        }
        ReactGA.event(ga4Params)
      } else if (selectedOption === 'option2') {
        navigator("/registration/payple");

        ga4Params = {
          "category": "Button",
          "action" : "Click",
          "label" : "3/3 complete: register payment-payple",
          "companyId" : 1
        }

        ReactGA.event(ga4Params)
      }
    }
  }; 

  useEffect (() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/onboarding/4/credit", title: "pay description view" })
    }
  },[])
  
  return (
    <NoLoginPage disable={false}>
      <Container>
        <Body>
          <TextContainer>
            <SmallText className="first"><span>2/2</span>단계</SmallText>
            <BigText className="Top">
              구독신청을 완료하고
              <br/> 무료체험으로 판단하세요
            </BigText>
            <SmallText className="small">
              원치 않는 결제시 100% 환불 보장
            </SmallText>
            <SmallText className="small">
              무료체험 먼저하시고 결정하세요.
            </SmallText>
          </TextContainer>
          <FirstContainer>
            <SmallText className="title">정기 구독 플랜</SmallText>
            <SubscriptionBox>
              <BigText className="Top">Basic 플랜</BigText>
              <SmallText className="small">무료배송</SmallText>
              <SmallText className="small">사진 5, 내지 1장</SmallText>
              <SmallText className="small">클라우드 평생 저장</SmallText>
              <TextContinerInbox>
                <ContextWrapper>지금 결제 금액</ContextWrapper>
                <SmallTextContainer>
                  <MiddleUnderline>₩8,900원</MiddleUnderline>
                  <ContextWrapper>0원</ContextWrapper>
                </SmallTextContainer>
              </TextContinerInbox>
              <ContentWrapper className="top">
                <ImgContainer>
                  <Img src="/images/card.png"/>
                </ImgContainer>
                월 ₩8,900
                </ContentWrapper>
                <ContentWrapper className="bottom">
                <ImgContainer>
                  <Img src="/images/calender.png"/>
                </ImgContainer>
                7월 25일 갱신예정
                </ContentWrapper>
            </SubscriptionBox>
          </FirstContainer>
          <SecondContainer>
            <TextContainer className="bottom">
              <BigText className="Top">결제는 나중에!<br/>지금 등록하면<br/>무료체험이 시작돼요</BigText>
              <SmallText className="small">
                결제전에는 카카오로 알려드리니
              </SmallText>
              <SmallText className="small">
                안심하고 등록하세요.
              </SmallText>
            </TextContainer>

            <SmallText className="title">결제 수단</SmallText>
            <RadioContainer>
              <Context className="radio">
                <PayRadioButton
                type="radio"
                name="kakao"
                value="option1"
                checked={selectedOption === 'option1'}
                onChange={handleOptionChange}
              >
                <span>카카오페이</span>
              </PayRadioButton>
                <ImgContainer className="kakao">
                  <Img src="/images/pay10.png"/>
                </ImgContainer>
              </Context>
              <Context className="radio">
                <PayRadioButton
                  type="radio"
                  name="papple"
                  value="option2"
                  checked={selectedOption === 'option2'}
                  onChange={handleOptionChange}
                >
                  <span>신용카드 또는 체크카드</span>
                </PayRadioButton>
                <ImgContainer className="pay">
                  <Img src="/images/card.png"/>
                </ImgContainer>
              </Context>
            </RadioContainer>
          </SecondContainer>
          <CheckedContainer>
            <SmallText className="title">이용약관</SmallText>
            <CheckBoxContainer>
              <Context className="context">
                <AgreeCheckBox
                  name="checkbox1"
                  checked={checkboxes.termsCondition && checkboxes.personalInformation && checkboxes.marketingConstent}
                  onChange={handleAllCheckboxChange}
                  className="subCheck"
                ><span>이용약관에 모두 동의합니다.</span></AgreeCheckBox>
              </Context>
              <SubCheckWrapper>
                <AgreeCheckBox
                  name="termsCondition"
                  checked={checkboxes.termsCondition}
                  onChange={handleCheckboxChange}
                  className="subCheck"
                ><span>[필수] 포티페타 이용약관</span></AgreeCheckBox>
              </SubCheckWrapper>
              <SubCheckWrapper>
                <AgreeCheckBox
                  name="personalInformation"
                  checked={checkboxes.personalInformation}
                  onChange={handleCheckboxChange}
                  className="subCheck"
                ><span>[필수] 개인정보 수집 이용 동의</span></AgreeCheckBox>
              </SubCheckWrapper>
              <SubCheckWrapper>
                <AgreeCheckBox
                  name="marketingConstent"
                  checked={checkboxes.marketingConstent}
                  onChange={handleCheckboxChange}
                  className="subCheck"
                ><span>[선택] 마케팅 수신 동의</span></AgreeCheckBox>
              </SubCheckWrapper>
            </CheckBoxContainer>
          </CheckedContainer>
          <BolleanContainer>
            <Balloon>
              <BalloonText className="top">등록 완료 하시면</BalloonText>
              <BalloonText className="bottom"><ChangeBoldText>무료체험</ChangeBoldText>이 자동으로 신청됩니다.</BalloonText>
            </Balloon>
          </BolleanContainer>
          <ButtonContainer>
            <SubmitButton
              isActive={!!(
                checkboxes.termsCondition === true && checkboxes.personalInformation === true
              )}
              onClick={handleCardRegistration}
            >완료
            </SubmitButton>
          </ButtonContainer>
        </Body>
      </Container>
    </NoLoginPage>
  )
}

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 24px 17px;
  background-color: #F5F3EF;
`;
const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  
  /* margin-bottom: 10px; */
  &.bottom {
    margin-bottom: 50px;
  }
`

const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 100%;
  color: #141414;
  @media (max-width:321px) {
    font-size: 10px;
  }

  &.title{
    font-size: 15px;
    @media (max-width:321px) {
    font-size: 13px;
  }
  }

  span {
    font-weight: 700;
  }
  &.first {
    margin-bottom: 15px;
  }
  &.Second {
    margin-top: 12.37px;
  }
  &.small {
    margin-top: 5px;
    color: rgba(117, 117, 117, 1);
    line-height: 15px;
  }
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  color: #141414;
  font-weight: bold;
  letter-spacing: -0.03em;
  @media (max-width:321px) {
    font-size: 20px;
  }

  &.Top {
    font-weight: 700;
    margin-bottom: 5px;
    line-height: 30px;
  }

  &.Bottom {
    font-weight: 300;
  }
`;
const FirstContainer = styled.div`
  width: 100%;
  margin-top: 50px ;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const Context = styled(ContextContainer)`
  height: 55px;
  display: flex;
  flex-direction: row;
  

  &.context {
    padding-top: 0;
    padding-left: 20px;
    justify-content: space-between;
    font-size: 10px;
    background-color: white;
    border-radius: 10px;
  }

  &.radio {
    /* background-color: var(--light-grey); */
    background-color: white;
    border-radius: 10px;
    font-family: 'Pret endard';
    
    font-style: normal;
    font-weight: 400;
    color: var(--dark-grey);
    align-items: center;
  }
  
  span {
    font-size: 15px;

    @media (max-width:321px) {
      font-size: 12px;
    }
    &.title{
      color:rgba(99, 99, 99, 1);
      font-family: 'Pretendard';
      font-style: normal;
      font-size: 13px;
      font-weight: 400;
      margin-top: 20px;
      
      @media (max-width:321px) {
        font-size: 10px;
      }
    }
    &.contents{
      margin-right: 23px;
      color: var(--black);


    }
    &.label {
      margin-left:14px;
      font-family: 'Pretendard';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 100%;
      color: #111111;
    }
  }
`
const SecondContainer = styled.div`
  width: 100%;
  /* height: 153px; */
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const RadioContainer = styled.div`
height: 119px;
display: flex;
flex-direction: column;
justify-content: space-between;
margin-top: 17px;

span{
  margin-left:14px;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 100%;

  color: #111111;
}
`
const CheckedContainer = styled.div`
  width: 100%;
  height: 185px;
  margin-top: 48px;
`
const CheckBoxContainer = styled.div`
  width: 100%;
  height: 153px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
`
const SubCheckWrapper = styled.div`
  width: 100%;
  height: 38.18px;
  padding-left: 25.14px;
  padding-top: 10px;

  span {
    margin-left: 5.89px;
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;

    @media (max-width:321px) {
      font-size:10px
    }
  }
`;
const BolleanContainer = styled.div`
  margin: 18px auto 0;
  max-width: 284px;
  height: 72.5px;
  background-color: antiquewhite;
`
const ChangeBoldText = styled.span`
  font-weight: Bold;
`;
const ButtonContainer = styled.div`
  /* width: 300px; */
  height: 52px;
  background-color: aliceblue;
  margin: 20px auto 0;
`;
const AgreeCheckBox =styled(Checkbox)`
  /* padding-left: 10px; */
`;
const PayRadioButton =styled(RadioButton)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ContextWrapper = styled.span`
`;

interface ButtonProps {
  isActive:boolean;
}
const SubmitButton = styled.button<ButtonProps>`
  background-color: #DBC6A7;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  /* border: 1px solid ${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)}; */
  /* color :${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)}; */
  color :${({ isActive }) => (isActive? 'rgba(255, 255, 255, 1)' : `rgba(177, 177, 177, 1)`)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
`;
const BalloonText = styled.p`
  font-size: 13px;
  &.top{
    padding-top: 17px;
  }
  &.bottom{
    margin-top: -10px;
  }
`;
const Body = styled.div`
  max-width: 344px;
  width: 100%;
  margin: 0 auto;
`

const SubscriptionBox = styled.div`
  margin-top: 15px;
  width: 100%;
  height: 241px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 21.30px 18.68px 0 16.33px;
`;
const TextContinerInbox = styled.div`
  display: flex;
  min-height: 30px;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 13.72px;
  border-bottom: 1px solid #DCDCDC;
  align-items: start;
`
const MiddleUnderline = styled.span`
  position: relative;
  display: inline-block;
  margin-right: 22.24px;
  color: #7E7E7E;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    border-bottom: 1px solid #7E7E7E; /* 밑줄의 색과 두께를 조정합니다 */
    transform: translateY(-50%);
  }
`;

const SmallTextContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ContentWrapper =styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  &.top{
    margin-top: 20.3px;
  }

  &.bottom {
    margin-top: 7.86px;
  }
`

const ImgContainer = styled.div`
  width: 13.52px;
  height: 12.42px;
  margin-right: 10.29px;

  &.pay{
    width: 20px;
    margin-right: 30.12px;
  }

  &.kakao {
    width: 60px;
    /* height: 40px; */
    margin-right: 15.12px;
  }

`
const Img = styled.img`
  width: 100%;
  /* height: 100%; */
`

